import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useTranslate } from "react-admin";
import { httpClient, apiUrl } from "../../restProvider";

export const isIphone = () => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    return /iPhone|iPod/.test(ua);
};

const sanitizeButtonProps = ({ activeClassName, ...props }) => props;

const LinkMemberAppleWallet = ({ label, children, ...props }) => {
    const translate = useTranslate();
    const walletUrl = `${apiUrl}/wallet/apple`;
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const handleClick = async (event) => {
        event.preventDefault();

        if (!isIphone()) {
            setOpen(true);
            return;
        }

        if (loading) return;
        setLoading(true);
        try {
            // Facultatif : valide la session
            await httpClient(`${apiUrl}/authtoken`);

            // Ouvre le .pkpass directement => Apple Wallet s’ouvre automatiquement
            window.location.href = walletUrl;
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button
                {...sanitizeButtonProps(props)}
                onClick={handleClick}
                disabled={loading}
                variant="text"
                color="default"
                size="small"
                style={{
                    padding: 0,
                    minWidth: 0,
                    background: "transparent",
                    boxShadow: "none",
                }}
            >
                {children || label}
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {translate("pages.account.appleWalletPopupTitle")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {translate("pages.account.appleWalletPopupMessage")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        color="secondary"
                        autoFocus
                    >
                        {translate("Fermer")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default LinkMemberAppleWallet;
